import {
  CreateEngineeringResponse,
  editEngineering,
} from "@/services/createSpace/engineering";
import mixCutDetailStore from "@/stores/mixCutDetailStore";
import { Message } from "@arco-design/web-react";
import moment from "moment";

interface IUseMixCutDetailMsgReturn {
  mixCutDetailMsg: CreateEngineeringResponse;
  handleChangeMixCutDetailMsg: (data: CreateEngineeringResponse) => void;
  handleChangeMixCutDetailMsgEngineer: (
    data: CreateEngineeringResponse,
  ) => void;
}

const useMixCutDetailMsg = (): IUseMixCutDetailMsgReturn => {
  const handleChangeMixCutDetailMsg = async (
    data: CreateEngineeringResponse,
  ) => {
    try {
      const a = await editEngineering({ ...data });
      console.log(a);
      mixCutDetailStore.setProjectMsg({
        ...data,
        updated_at: moment().format("YYYY-MM-DD HH:mm") as any,
      });
    } catch (e) {
      Message.error(e);
      console.log(e);
    }
  };
  return {
    mixCutDetailMsg: mixCutDetailStore.getProjectMsg(),
    handleChangeMixCutDetailMsg,
    handleChangeMixCutDetailMsgEngineer: mixCutDetailStore.setProjectMsg,
  };
};

export default useMixCutDetailMsg;
